import { apiClient } from "./client";
import { TERMS_VERSION } from "@/shared/constants/legal";

export const acceptCurrentTerms = async () => {
  const result = await apiClient<{ version: string }>("/auth/terms-acceptance", { method: "POST" });
  if (result.version !== TERMS_VERSION) throw new Error("Terms version mismatch");
};
